module.exports = __webpack_public_path__ + "static/media/splash.c3c67061.png";